import { Star, PenLine } from "lucide-react";
import BrickTitle from "@/components/landing/BrickTitle";

export default function Reviews() {
  return (
    <section id="reviews" className="py-20 bg-[#1B2229] border-y border-[#3A4752]" data-testid="reviews-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs font-bold uppercase tracking-widest text-[#D4691E]">Community Trust</span>
          <h2 className="text-3xl font-bold mt-2">
            <BrickTitle text="Reputation Built One Honest Fix at a Time" />
          </h2>
          <p className="text-sm text-[#736B63] mt-3">
            We let our meticulous care and long-lasting repairs speak directly for our quality.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-xl border border-[#E6DCD3] flex flex-col justify-between" data-testid="review-card-1">
            <div>
              <div className="flex items-center gap-1 text-[#D4691E] mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <p className="text-sm text-[#544D45] italic leading-relaxed">
                &ldquo;Fixed our AC unit during the hottest week of July when two other contractors wanted to charge
                over $1,200 for full replacements. Honest, respectful of our hardwood floors, and completely upfront on
                cost.&rdquo;
              </p>
            </div>
            <div className="mt-6 pt-4 border-t border-[#F0EAE1]">
              <span className="block font-bold text-xs text-[#1E252B]">Local Homeowner</span>
              <span className="text-[11px] text-[#8C847B]">AC Diagnostic &amp; Repair</span>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl border border-[#E6DCD3] flex flex-col justify-between" data-testid="review-card-2">
            <div>
              <div className="flex items-center gap-1 text-[#D4691E] mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <p className="text-sm text-[#544D45] italic leading-relaxed">
                &ldquo;Welded our heavy driveway iron gate back onto its masonry post and built a custom matching oak
                shelf for our hallway. The versatility is unreal. Having one trustworthy person for all repairs is a
                game changer.&rdquo;
              </p>
            </div>
            <div className="mt-6 pt-4 border-t border-[#F0EAE1]">
              <span className="block font-bold text-xs text-[#1E252B]">Rental Property Manager</span>
              <span className="text-[11px] text-[#8C847B]">Welding &amp; Woodwork</span>
            </div>
          </div>

          <div className="bg-[#FFFDFB] p-6 rounded-xl border-2 border-dashed border-[#DCD3C9] flex flex-col justify-between items-center text-center" data-testid="review-card-invite">
            <div className="my-auto">
              <PenLine className="w-7 h-7 text-[#D4691E] mb-2 mx-auto" />
              <span className="font-bold text-sm text-[#1E252B] block">Your Experience Goes Here</span>
              <p className="text-xs text-[#736B63] mt-2">
                Every customer is treated with utmost respect. Experience our craftsmanship on your next repair project.
              </p>
            </div>
            <a href="#contact" data-testid="review-invite-link" className="mt-4 text-xs font-bold text-[#D4691E] hover:underline">
              Request a quote today &rarr;
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
